var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"step"},[_c('div',{staticClass:"step--stepper"},[_c('span',[_vm._v(_vm._s(_vm.step))])]),_c('div',[_c('div',{staticClass:"step--title"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_vm._t("actions")],2),_c('v-divider',{staticClass:"mb-3"}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }